import React, { MouseEvent } from "react";
import { Grid } from "@mui/material";
import { DroppsProduct, ScentDetails, productSelect } from "@/store";
import { SvgSrcIcon } from "@/components/SvgSrcIcon";
import { storefrontApi } from "@/services/storefront";
import { useHasProductRouter } from "./ProductRouter";
import { usePdpActions } from "./PdpContext";

type ScentButtonProps = {
  scent: ScentDetails;
  focused: boolean;
  hoverAction?: boolean;
};

export const ScentButton = ({
  scent,
  focused,
  hoverAction = true,
}: ScentButtonProps) => {
  const actions = usePdpActions();
  const isRoutable = useHasProductRouter();
  const url = productSelect.url(scent);
  const product = storefrontApi.useHandle(scent.handle);

  const handleScentUnfocus = () => actions.unfocusProduct();
  const handleScentFocus =
    product.data === undefined
      ? undefined
      : () => actions.focusProduct(product.data);
  const handleScentSelect =
    (product: DroppsProduct) => (e: MouseEvent<HTMLElement>) => {
      e.preventDefault();
      actions.selectProduct(product);
    };

  const buttonProps = hoverAction
    ? {
        onClick:
          product.data === undefined
            ? undefined
            : handleScentSelect(product.data),
        onFocus: handleScentFocus,
        onBlur: handleScentUnfocus,
      }
    : {
        onClick:
          product.data === undefined
            ? undefined
            : handleScentSelect(product.data),
      };

  const child = (
    <SvgSrcIcon src={scent.icon} height={40} width={40} title={scent.name} />
  );

  return (
    <Grid
      item
      onMouseEnter={hoverAction ? handleScentFocus : undefined}
      onMouseLeave={hoverAction ? handleScentUnfocus : undefined}
    >
      <div
        data-id="scents-button"
        className={`flex rounded-full ring-primary transition-all ${
          focused ? "ring" : "ring-1"
        }`}
        style={{ backgroundColor: scent.color }}
      >
        {isRoutable ? (
          <a aria-label={scent.name} href={url} {...buttonProps}>
            {child}
          </a>
        ) : (
          <button
            className="border-none bg-transparent p-0"
            {...buttonProps}
            title={"Set scent to " + scent.name}
          >
            {child}
          </button>
        )}
      </div>
    </Grid>
  );
};
